import { defer, MonoTypeOperatorFunction, Observable } from 'rxjs';
import { map, scan, tap } from 'rxjs/operators';

const present = () => {
  return process ? hrtime() : performance.now();
};

// source: https://github.com/dbkaplun/present/blob/master/lib/present-node.js
const hrtime = () => {
  const time = process.hrtime();
  return time[0] * 1e3 + time[1] / 1e6;
};

/**
 * Measures the elapsed time between each emission from the source observable and calls the provided callback with the value.
 * @returns identical observable as the source
 * */
export function timeTaken<T>(log: (value: number) => void): MonoTypeOperatorFunction<T> {
  const seed = () => {
    const value: T = undefined;
    const last: number = undefined;
    return { current: present(), last, value };
  };

  return (source: Observable<T>): Observable<T> =>
    defer(() => {
      return source.pipe(
        scan(({ current }, value: T) => ({ value, current: present(), last: current }), seed()),
        tap(({ current, last }) => log(current - last)),
        map(({ value }) => value)
      );
    });
}
